import { createContext } from "react";
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { ColorSystem, colors } from "../../designSystem/colors/color";
import { AmorgStyles, amorgStyles } from "../../designSystem/styles/amorgStyles";

type AmorgAdminPageContextType = {
    colors:ColorSystem,
    styles:AmorgStyles
}

export const AmorgAdminPageContext = createContext<AmorgAdminPageContextType>({colors, styles:amorgStyles(colors)});

type AmorgAdminPageProviderProps = {
    children?:React.ReactNode
}
export function AmorgAdminPageProvider(props:AmorgAdminPageProviderProps):JSX.Element
{

    const styles = amorgStyles(colors);

    return (
        <AmorgAdminPageContext.Provider value={{colors, styles}}>

            {/* Type of theme is defined in styled.d.ts */}
            <ThemeProvider theme={{colors, styles}}>
                <Main>
                {props.children}
                </Main>
            </ThemeProvider>
            
        </ AmorgAdminPageContext.Provider>
    )
}

const Main = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-columns: auto;
    grid-template-rows: auto;
    

`;